<div class="sub-header px-3">
  <!-- <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb> -->
</div>

<div class="search-container align-items-center d-flex row mb-4 px-3 py-3 pb-4">
  <h4 class="col-md-5 mb-0">Content Management</h4>
</div>

<ng-container>
  <app-content-dashboard></app-content-dashboard>
</ng-container>